import warningIconGradient from "@assets/images/exclamation.svg";
import { Box, Button, Dialog, makeStyles, Typography } from "@material-ui/core";
import React from "react";

interface DialogSplitErrorProps {
  errorItems?: string;
  errorSource?: string;
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const useStyles = makeStyles(
  theme => ({
    buttonText: {
      color: "white",
      fontSize: "18px"
    },
    btnBackGroundGradient: {
      background:
        "linear-gradient(90deg, #601863 0%, #681661 12%, #81125C 32%, #A90C55 57%, #DF044A 86%, #FD0045 100%)",
      border: "none",
      color: "#ffffff",
      height: "48px",
      marginTop: "32px",
      "& .MuiTypography-root": {
        color: "#FFFFFF"
      },
      "&:hover": {
        border: "none"
      }
    },
    contentFlex: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center"
    },
    content: {
      fontFamily: "SCG",
      fontSize: "18px",
      fontStyle: "normal",
      fontWeight: 500,
      lineHeight: "24px",
      textAlign: "center"
    },
    dialog: {
      borderRadius: "16px",
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.25)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      minHeight: "200px",
      padding: theme.spacing(3),
      width: "420px"
    },
    succcesType: {
      alignItems: "center",
      display: "flex",
      justifyContent: "center",
      marginBottom: "12px",
      marginTop: "12px"
    },
    title: {
      fontSize: "20px",
      fontWeight: 700
    }
  }),
  { name: "DialogSplitError" }
);

const DialogSplitError: React.FC<DialogSplitErrorProps> = ({
  onCancel,
  onConfirm,
  open,
  errorSource,
  errorItems
}) => {
  const classes = useStyles();

  return (
    <Dialog
      open={open}
      keepMounted
      onClose={onCancel}
      onClick={onConfirm}
      PaperProps={{
        style: { borderRadius: 16 }
      }}
    >
      <Box className={classes.dialog}>
        <div className={classes.contentFlex}>
          <img
            src={warningIconGradient}
            alt="Warning Icon"
            style={{ width: "40px", height: "40px" }}
          />
        </div>
        <div className={classes.succcesType}>
          <Typography className={classes.title}>
            ไม่สามารถดำเนินการได้
          </Typography>
        </div>
        <div className={classes.contentFlex}>
          <Typography className={classes.content}>
            Error {errorSource ?? ""} : {errorItems}
          </Typography>
        </div>

        <Button
          id="closeSplitErrorModal"
          data-testid="closeSplitErrorModal"
          className={classes.btnBackGroundGradient}
          onClick={onConfirm}
        >
          <Typography className={classes.buttonText}>ปิดหน้าต่าง</Typography>
        </Button>
      </Box>
    </Dialog>
  );
};
export default DialogSplitError;
